/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-floating-promises */
import { observable, action } from 'mobx';
import type { Concept, ConceptSearchPayload, ConceptChangeOrderPayload } from 'components/next/types';
import * as _ from 'lodash';
import { StoreState } from 'enums/common';

export default class ConceptsStore {
  client;

  @observable concepts: Concept[] = [];
  @observable concept: Concept = undefined;
  @observable error: string = undefined;
  @observable count = 0;
  @observable status: StoreState = StoreState.ready;

  @action async search(payload: ConceptSearchPayload = {}, parameters = {}) {
    // _.set(parameters);
    this.status = StoreState.loading;
    const result = await this.client.searchConcepts(parameters, payload);
    this.count = result.data.count;
    this.setConcepts(result.data.result);
    return result.data;
  }

  @action setConcepts(concepts) {
    // Remove deliveryCode field when feature flag is disabled
    if (process.env.REACT_APP_DELIVERY_CODE !== 'true') {
      concepts = concepts.map((c) => _.omit(c, 'deliveryCode'));
    }
    this.concepts = concepts;
    this.status = StoreState.ready;
  }

  @action setConcept(concept) {
    // Remove deliveryCode field when feature flag is disabled
    if (process.env.REACT_APP_DELIVERY_CODE !== 'true' && concept) {
      concept = _.omit(concept, 'deliveryCode');
    }
    this.concept = concept;
  }

  @action async findById(id: number) {
    const result = await this.client.getConcept({ conceptId: id });
    if (result.status === 200) {
      this.setConcept(result.data);
      return result.data;
    }

    return null;
  }

  @action async findLastUpdateById(id: number) {
    const result = await this.client.getConceptLastUpdated({ conceptId: id });
    if (result.status === 200) {
      return result.data;
    }

    return null;
  }

  @action setError(message: string) {
    this.error = message;
  }

  @action setClient(client) {
    this.client = client;
  }

  @action async replaceConcept(program: Concept) {
    this.status = StoreState.loading;
    try {
      const result = await this.client.replaceConcept({ conceptId: program.id }, program);
      if (result.status === 200) {
        this.setConcept(result.data);
        return result.data;
      } else {
        this.setError(result.message);
      }
    } catch (error) {
      this.status = StoreState.error;
    }
  }

  @action async createConcept(program: Concept) {
    this.status = StoreState.loading;
    try {
      const result = await this.client.createConcept(null, _.omit(program, 'conceptStoreAutomaticParticipation'));
      if (result.status === 201) {
        this.search();
        return result.data;
      }
    } catch (error) {
      this.status = StoreState.error;
    }
  }

  @action async deleteConcept(id: string) {
    const result = await this.client.deleteConcept({ conceptId: parseInt(id, 10) });
    if (result.status === 200) {
      this.search();
    }
  }

  @action async changeConceptOrder(id: string, payload: ConceptChangeOrderPayload) {
    await this.client.changeConceptOrder({ conceptId: parseInt(id, 10) }, payload);
  }
}
